import { render } from "./GuideCard.vue?vue&type=template&id=995dc5ce&ts=true"
import script from "./GuideCard.vue?vue&type=script&lang=ts"
export * from "./GuideCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__